class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.querySelector('#CartDrawer-Close').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
    this.classList.remove('invisible');
    this.querySelector('#CartDrawer-Overlay').classList.remove('opacity-0');
    this.querySelector('#CartDrawer-Overlay').classList.add('opacity-50');
    this.querySelector('#CartDrawer-Sidebar').classList.remove('translate-x-full');

    const scrollbarWidth = window.innerWidth - document.body.offsetWidth;
    document.body.classList.add('overflow-y-hidden');
    document.body.style.paddingRight = scrollbarWidth + 'px';
    document.querySelector('header').style.paddingRight = scrollbarWidth + 'px';

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.querySelector('#CartDrawer-Sidebar');
        const focusElement = this.querySelector('#CartDrawer-Inner') || this.querySelector('#CartDrawer-Close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() {
    removeTrapFocus(this.activeElement);

    this.classList.add('invisible');
    this.querySelector('#CartDrawer-Overlay').classList.add('opacity-0');
    this.querySelector('#CartDrawer-Overlay').classList.remove('opacity-50');
    this.querySelector('#CartDrawer-Sidebar').classList.add('translate-x-full');

    document.body.classList.remove('overflow-y-hidden');
    document.body.style.paddingRight = 0;
    document.querySelector('header').style.paddingRight = 0;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('#CartDrawer-Inner').classList.contains('is-empty') &&
      this.querySelector('#CartDrawer-Inner').classList.remove('is-empty');
    
    const items = document.querySelector('cart-drawer-items').querySelectorAll('.cart-item');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    /* undo cart */
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    const cartUndo = cartDrawerItems.dataset.undo;
    if (cartUndo == 'true') {
      Array.from(items).forEach(function(item, index) {
        if (item.classList.contains('undoing')) {
          if (cartDrawerItems.querySelectorAll('.cart-item')[index+1]) {
            cartDrawerItems.querySelector('.cart-items').insertBefore(item, cartDrawerItems.querySelectorAll('.cart-item')[index+1]);
          } else {
            cartDrawerItems.querySelector('.cart-items').append(item);
          }
        }
      });
    }

    // setTimeout(() => {
    //   this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    //   this.open();
    // });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      
      const closeBtn = this.querySelector('#CartDrawer-Close');
      if (closeBtn) {
        closeBtn.addEventListener('click', this.close.bind(this));
      }

      this.open();
    });

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer-Sidebar',
        section: 'cart-drawer',
        selector: '#CartDrawer-Inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
